namespace GeniuzPOS.ReportMasterData {
    export interface Report_1503_NForm {
        Year: Serenity.LookupEditor;
        SubCat2Code: Serenity.StringEditor;
        SubCat2Name: Serenity.StringEditor;
    }

    export class Report_1503_NForm extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1503_N';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1503_NForm.init)  {
                Report_1503_NForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(Report_1503_NForm, [
                    'Year', w0,
                    'SubCat2Code', w1,
                    'SubCat2Name', w1
                ]);
            }
        }
    }
}
